import '@microcharts/react/styles.css'
import '@microcharts/react/motion'
import './index.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { installStaleAssetRecovery } from '../../components/recoverStaleAssets'
import store from './redux'
import { queryClient } from './lib/query-client'
import App from './components'
import ErrorMessage from './components/common/ErrorMessage'
import ThemedToaster from './components/common/ThemedToaster'
import { SentryErrorBoundary } from './tracking/trackingScripts'
import { ThemeProvider } from './contexts/ThemeContext'
import { DemoModeProvider } from './contexts/DemoModeContext'
import { FeedbackModeProvider } from './components/common/MarkupFeedback/FeedbackModeContext'
import { markInsightsInitialNavigation } from './performance/insightsPerformance'

installStaleAssetRecovery()
markInsightsInitialNavigation()

const containerElement = document.getElementById('root')
const reactRoot = createRoot(containerElement)

reactRoot.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <DemoModeProvider>
        <FeedbackModeProvider>
          <ThemedToaster />
          <SentryErrorBoundary FallbackComponent={ErrorMessage}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SentryErrorBoundary>
        </FeedbackModeProvider>
      </DemoModeProvider>
    </ThemeProvider>
    </QueryClientProvider>
  </Provider>,
)
